(()=>{
  const qs=(selector,context=document)=>context.querySelector(selector);
  const qsa=(selector,context=document)=>Array.from(context.querySelectorAll(selector));

  const toast=(message)=>{
    const el=qs('[data-gm-toast]');
    if(!el) return;
    el.textContent=message;
    el.classList.add('is-visible');
    clearTimeout(window.__gmToast);
    window.__gmToast=setTimeout(()=>el.classList.remove('is-visible'),2600);
  };

  qsa('[data-gm-menu]').forEach((button)=>{
    const menu=document.getElementById(button.getAttribute('aria-controls'));
    if(!menu) return;
    const close=()=>{
      button.setAttribute('aria-expanded','false');
      menu.hidden=true;
      document.documentElement.classList.remove('gm-menu-open');
    };
    button.addEventListener('click',()=>{
      const open=button.getAttribute('aria-expanded')==='true';
      if(open){
        close();
      }else{
        button.setAttribute('aria-expanded','true');
        menu.hidden=false;
        document.documentElement.classList.add('gm-menu-open');
      }
    });
    qsa('a',menu).forEach((link)=>link.addEventListener('click',close));
    window.addEventListener('resize',()=>{ if(window.innerWidth>1080) close(); },{passive:true});
  });

  qsa('[data-gm-watch-picker]').forEach((button)=>{
    const name=button.dataset.gmWatchPicker;
    const key='gms-watch-'+name.toLowerCase().replace(/[^a-z0-9]+/g,'-');
    if(localStorage.getItem(key)==='1'){
      button.classList.add('is-watching');
      button.textContent='Watching';
    }
    button.addEventListener('click',()=>{
      const watching=localStorage.getItem(key)==='1';
      if(watching){
        localStorage.removeItem(key);
        button.classList.remove('is-watching');
        button.textContent='Watch picker';
        toast(`Stopped watching ${name} on this device.`);
      }else{
        localStorage.setItem(key,'1');
        button.classList.add('is-watching');
        button.textContent='Watching';
        toast(`${name} saved to your local watchlist. Connect Discord for real alerts when enabled.`);
      }
    });
  });

  qsa('[data-gm-live]').forEach(async (el)=>{
    const base=(el.dataset.api||'').replace(/\/$/,'');
    if(!base) return;
    const note=qs('[data-state-note]',el);
    try{
      const response=await fetch(base+el.dataset.endpoint,{headers:{accept:'application/json'}});
      if(!response.ok) throw new Error('GMS API unavailable');
      const data=await response.json();
      if(note) note.textContent='LIVE GMS DATA';
      el.dispatchEvent(new CustomEvent('gms:data',{detail:data}));
    }catch(error){
      if(note) note.textContent='DEMO — LIVE API UNAVAILABLE';
    }
  });
})();
